import { Link, useLocation } from 'react-router-dom';
import { useFeature } from '../../context/AuthContext';
import './NotFoundPage.css';

/**
 * Catch-all for addresses no route matches. Before this existed an unknown
 * path rendered the app chrome around an empty content area, which reads as
 * "broken" rather than "wrong address". It shows the path that was asked for,
 * so a typo is easy to spot, and links back to the root page.
 */
export default function NotFoundPage() {
  const { pathname } = useLocation();
  const homeOn = useFeature('home_dashboard');

  return (
    <div className="main-content-inner nf">
      <div className="nf-num" aria-hidden="true">4<em>0</em>4</div>
      <div className="nf-copy">
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-text">
          There&apos;s no page at <code className="nf-path">{pathname}</code> in Nexus.
          It may have moved, or the address has a typo.
        </p>
        <div>
          <Link className="btn btn-primary" to="/">{homeOn ? 'Go to Home' : 'Go to My tools'}</Link>
        </div>
      </div>
    </div>
  );
}
